export default __webpack_public_path__ + "content/media/18.f96fa322.jpg";